function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import systemPropTypes from '@styled-system/prop-types';
import * as styledSystem from 'styled-system';
import PropTypes from 'prop-types';
import { addGroupData } from "./utils";
var compose = styledSystem.compose,
    system = styledSystem.system;
var COMMON = compose(styledSystem.color, styledSystem.space);
COMMON.systemNames = ['color', 'space']; // typography

var whiteSpace = system({
  whiteSpace: {
    property: 'whiteSpace',
    cssProperty: 'whiteSpace'
  }
});
var textTransform = system({
  textTransform: {
    property: 'textTransform'
  }
});
var TYPOGRAPHY = compose(styledSystem.typography, whiteSpace, textTransform);
TYPOGRAPHY.systemNames = ['typography'];
TYPOGRAPHY.propTypes = _objectSpread(_objectSpread({}, systemPropTypes.typography), {}, {
  whiteSpace: PropTypes.oneOf(['normal', 'nowrap', 'pre-wrap', 'pre', 'pre-line']),
  textTransform: PropTypes.oneOf(['none', 'uppercase', 'lowercase', 'capitalize'])
});
var BORDER = compose(styledSystem.border, styledSystem.shadow);
BORDER.systemNames = ['border', 'shadow'];

var layoutConfig = _objectSpread({}, styledSystem.layout.config);

delete layoutConfig.size;
var LAYOUT = compose(system(layoutConfig));
var POSITION = styledSystem.position;
var FLEX = styledSystem.flexbox;
COMMON.propTypes = _objectSpread(_objectSpread({}, systemPropTypes.space), systemPropTypes.color);
BORDER.propTypes = _objectSpread(_objectSpread({}, systemPropTypes.border), systemPropTypes.shadow);
LAYOUT.propTypes = systemPropTypes.layout;
POSITION.propTypes = systemPropTypes.position;
FLEX.propTypes = systemPropTypes.flexbox;
COMMON.propGroups = {
  color: {
    name: 'color',
    pattern: '^c'
  },
  bg: {
    name: 'bg',
    pattern: '^b'
  },
  opacity: {
    name: 'opacity'
  },
  margin: {
    name: 'margin',
    pattern: '^m'
  },
  padding: {
    name: 'padding',
    pattern: '^p'
  }
};
BORDER.propGroups = {
  border: {
    name: 'border',
    pattern: '^border$|^borderX$|^borderY$'
  },
  borderWidth: {
    name: 'borderWidth'
  },
  borderStyle: {
    name: 'borderStyle'
  },
  borderColor: {
    name: 'borderColor'
  },
  borderRadius: {
    name: 'borderRadius',
    pattern: 'Radius$'
  },
  borderTop: {
    name: 'borderTop',
    pattern: '^borderTop'
  },
  borderRight: {
    name: 'borderRight',
    pattern: '^borderRight'
  },
  borderBottom: {
    name: 'borderBottom',
    pattern: '^borderBottom'
  },
  borderLeft: {
    name: 'borderLeft',
    pattern: '^borderLeft'
  },
  boxShadow: {
    name: 'boxShadow',
    pattern: 'Shadow$'
  }
};
TYPOGRAPHY.propGroups = {
  fontSize: {
    name: 'fontSize'
  },
  fontWeight: {
    name: 'fontWeight'
  },
  fontFamily: {
    name: 'fontFamily'
  },
  fontStyle: {
    name: 'fontStyle'
  },
  textTransform: {
    name: 'textTransform'
  },
  textAlign: {
    name: 'textAlign'
  },
  whiteSpace: {
    name: 'whiteSpace'
  },
  lineHeight: {
    name: 'lineHeight'
  },
  letterSpacing: {
    name: 'letterSpacing'
  }
};
LAYOUT.propGroups = {
  display: {
    name: 'display'
  },
  width: {
    name: 'width',
    pattern: '^width|Width$'
  },
  height: {
    name: 'height',
    pattern: '^height|Height$'
  },
  overflow: {
    name: 'overflow'
  },
  verticalAlign: {
    name: 'verticalAlign'
  }
};
POSITION.propGroups = {
  position: {
    name: 'position'
  },
  zIndex: {
    name: 'zIndex'
  },
  top: {
    name: 'top'
  },
  right: {
    name: 'right'
  },
  left: {
    name: 'left'
  },
  bottom: {
    name: 'bottom'
  }
};
FLEX.propGroups = {
  alignItems: {
    name: 'alignItems'
  },
  justifyContent: {
    name: 'justifyContent'
  },
  flexBasis: {
    name: 'flexBasis'
  },
  flexGrow: {
    name: 'flexGrow'
  },
  flexShrink: {
    name: 'flexShrink'
  },
  flexDirection: {
    name: 'flexDirection'
  },
  flexWrap: {
    name: 'flexWrap'
  },
  alignContent: {
    name: 'alignContent'
  },
  justifyItems: {
    name: 'justifyItems'
  },
  order: {
    name: 'order'
  },
  flex: {
    name: 'flex'
  },
  justifySelf: {
    name: 'justifySelf'
  },
  alignSelf: {
    name: 'alignSelf'
  }
};
COMMON.propGroupName = 'COMMON';
TYPOGRAPHY.propGroupName = 'TYPOGRAPHY';
BORDER.propGroupName = 'BORDER';
LAYOUT.propGroupName = 'LAYOUT';
POSITION.propGroupName = 'POSITION';
FLEX.propGroupName = 'FLEX';
var NeoSystem = addGroupData({
  COMMON: COMMON,
  TYPOGRAPHY: TYPOGRAPHY,
  BORDER: BORDER,
  LAYOUT: LAYOUT,
  POSITION: POSITION,
  FLEX: FLEX
});
export default NeoSystem;
export { NeoSystem };